import React from 'react';

interface CalculatorButtonsProps {
  onCalculate: () => void;
  onReset: () => void;
}

export const CalculatorButtons: React.FC<CalculatorButtonsProps> = ({ onCalculate, onReset }) => {
  return (
    <div className="flex gap-4 mt-6">
      <button
        onClick={onCalculate}
        className="px-6 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors"
      >
        Calculate
      </button>
      <button
        onClick={onReset}
        className="px-6 py-2 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 transition-colors"
      >
        Reset
      </button>
    </div>
  );
};